export { default } from './StylesProvider';
export * from './StylesProvider';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/StylesProvider/index.js
// module id = 470
// module chunks = 121